const listeners = new Set();
/** Subscribe to resolved-theme changes; returns an unsubscribe function. */
export function subscribeTheme(listener) {
    listeners.add(listener);
    return () => {
        listeners.delete(listener);
    };
}
/**
 * @internal Called by ThemeProvider after stamping `<html>`. Not part of the
 * public API.
 *
 * Each listener is isolated. This runs inside ThemeProvider's
 * `useLayoutEffect`, so an unguarded throw from ONE subscriber does not just
 * lose that subscriber — it skips every listener after it (the i18n language
 * bridge, the chart-direction bridge, the Electron `nativeTheme` mirror) and
 * errors the React commit. That is a white screen. A subscriber must not be
 * able to abort the theme commit, so failures are reported and swallowed.
 */
export function emitTheme(theme) {
    for (const listener of [...listeners]) {
        try {
            listener(theme);
        }
        catch (error) {
            console.error('[theme] subscriber threw; continuing with the remaining listeners', error);
        }
    }
}
//# sourceMappingURL=subscribe.js.map